import { useEffect } from 'react';
import {
  startPagePerf,
  markPagePerfDataLoaded,
  finishPagePerfAndFlush,
  isPerfDiagnosticsEnabled,
  sanitizeRouteParams,
} from '../utils/pagePerf';

/**
 * Sayfa görünürlüğü boyunca perf oturumu; unmount'ta sunucuya gönderir (opt-in).
 * @param {string} pageKey
 * @param {Record<string,string>} routeParams
 * @param {{ markFirstDataImmediate?: boolean }} options — statik sayfalar için true
 */
export function usePagePerf(pageKey, routeParams = {}, options = {}) {
  const { markFirstDataImmediate = false } = options;
  const paramsKey = JSON.stringify(sanitizeRouteParams(routeParams));

  useEffect(() => {
    if (!isPerfDiagnosticsEnabled()) return undefined;

    let params = {};
    try {
      params = JSON.parse(paramsKey);
    } catch {
      params = {};
    }
    startPagePerf(pageKey, params);
    if (markFirstDataImmediate) {
      queueMicrotask(() => markPagePerfDataLoaded());
    }

    return () => {
      void finishPagePerfAndFlush();
    };
  }, [pageKey, paramsKey, markFirstDataImmediate]);
}

/** Veri yüklendiğinde çağır (ör. loading false olduğunda) */
export { markPagePerfDataLoaded } from '../utils/pagePerf';
